import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="page narrow-page">
      <div className="empty-state">
        <span className="eyebrow">404</span>
        <h1>找不到這個頁面</h1>
        <p>網址可能已變更，或作品已停止分享。</p>
        <Link className="button button--primary" to="/">
          回首頁
        </Link>
      </div>
    </div>
  )
}

